// types/enums.ts
export enum FeeCategory {
	APPLICATION = "APPLICATION",
	DOWN_PAYMENT = "DOWN_PAYMENT",
	TUITION = "TUITION",
}

export enum PaymentPlan {
	SEMESTER = "SEMESTER",
	YEAR = "YEAR",
	FULL = "FULL",
	LOAN = "LOAN",
}

export enum TransactionGateway {
	Razorpay = "RAZORPAY",
	Stripe = "STRIPE",
	Easebuzz = "EASEBUZZ",
}

export type CONFIG = {
	student_dashboard_origins: string[]
	ams_dashboard_origins: string[]
}
